
// @ngInject
function stateChangeReportController(ApiUrl) {
    this.data = {};
    this.getReportUrl = function(params) {
        var base = ApiUrl('state_change_log', 'export.xlsx');
        var parts = [];
        for (var name in params) {
            if (params[name]) {
                parts.push(name + '=' + encodeURIComponent(params[name]));
            }
        }
        return base + "?" + parts.join('&');
    }
}

function stateChangeReportController($scope, $stateParams, $state, ModelService) {
    var vm = this;

    var reportUrl = $state.current.data.reportUrl;

    vm.views = [];

    vm.loading = false;
    vm.sort = $stateParams.sort;
    vm.tags = {};

    vm.pageSize = 20;
    vm.page = $stateParams.page;

    vm.offset = 0

    vm.refresh = refresh;
    vm.tagChange = tagChange;

    $scope.$watch('$ctrl.page', pageChange);
    $scope.$watch('$ctrl.search', searchChange);

    function refresh() {
        var params = angular.copy(vm.tags);
        params.sort = vm.sort;
        loadViews(params);
    }

    function pageChange(page) {
        vm.offset = (page - 1) * vm.pageSize;
        $state.go('.', {page: page}, {location: 'replace'});
    }

    function searchChange(newSearch, oldSearch) {
        if (newSearch) { vm.page = 1; }
    }

    function tagChange(params) {
        vm.tags = params;
        refresh();
    }

    function loadViews(params) {
        vm.loading = true;
        $state.go('.', params, {location: 'replace'});
        return ModelService.index(reportUrl, params).then(setViews)
    }

    function setViews(views) {
        angular.copy(views, vm.views);
        vm.loading = false;
        vm.page = 1;
        vm.pages = Math.ceil(vm.views.length / vm.pageSize);
        return vm.views;
    }

}


// @ngInject
function stateChangeStates($stateProvider, TagUrl) {

    var tagUrl = new TagUrl()
        .addTagTypes(['program', 'location'])
        .addExtraParam('page', {value: 1, type: 'int', squash: true})
        .addExtraParam('sort', {value: '-start', squash: true});

    $stateProvider.state('reports.stateChangeLog', {
        url: '/state-change-log',
        permission: 'editUsers',
        templateUrl: 'reports/history/stateChange',
        data: {title: 'State Change Log'},
    });

    function makeReportState(endpoint, title) {
        var url = endpoint.split('_').join('-')
        $stateProvider.state('reports.stateChangeLog.' + endpoint, {
            url: tagUrl.buildUrl('/' + url),
            params: url.params,
            data: {tagUrl: tagUrl, title: title,
                   reportUrl: 'state_change_log/' + endpoint},
            templateUrl: 'reports/history/stateChange_' + endpoint,
            controller: stateChangeReportController,
            controllerAs: '$ctrl',
            reloadOnSearch: false,
        });
    }

    makeReportState('student_views', 'Student Views');
    makeReportState('sessions',      'Sessions');


    $stateProvider.state('reports.stateChangeLog.session', {
        url: '/sessions/{uuid}',
        views: {
            '@reports': {
                templateUrl: 'reports/history/stateChange_session',
                controllerAs: '$ctrl',
                controller: function(session) {
                    this.session = session;
                },
                resolve: {
                    session: function($stateParams, ModelService) {
                        return ModelService.get('state_change_log/session',
                                                $stateParams.uuid);
                    }
                }
            }
        }
    });


    $stateProvider.state('reports.stateChangeLog.transitions', {
        url: "/transitions",
        templateUrl: 'reports/history/stateChangeTransitions',
        data: {title: 'Unique Transitions'},
        reloadOnSearch: false,
        resolve: {transitions: resolveTransitions},
        controllerAs: '$ctrl',
        controller: function($stateParams, transitions) {
            this.transitions = transitions;
            this.sort = "-count";
        },
    });


    $stateProvider.state('reports.stateChangeLog.states', {
        url: "/states",
        templateUrl: 'reports/history/stateChangeStates',
        data: {title: 'States'},
        reloadOnSearch: false,
        resolve: {states: resolveStates},
        controllerAs: '$ctrl',
        controller: function($stateParams, states) {
            this.states = states;
            this.sort = "+name";
        },
    });

    $stateProvider.state('reports.stateChangeLog.state', {
        url: "/states/{name}",
        resolve: {state: resolveState },
        views: {'@reports': {
            templateUrl: 'reports/history/stateChangeState',
            controllerAs: '$ctrl',
            controller: function(state) {
                this.state = state;
                this.columns = [
                    {title: 'Where people come here from', items: state.transitions_to},
                    {title: 'Where people go to from here', items: state.transitions_from},
                ]
            }
        }}
    });

    function resolveStates(ModelService) {
        return ModelService.index('state_change_log/states');
    }

    function resolveTransitions(ModelService) {
        return ModelService.index('state_change_log/transitions');
    }

    function resolveState($stateParams, ModelService) {
        return ModelService.get('state_change_log/state', $stateParams.name)
    }

    $stateProvider.state('reports.stateChangeLog.export', {
        url: '/export',
        templateUrl: 'reports/history/stateChangeExport',
        controllerAs: 'ctrl',
        controller: stateChangeReportController,
        data: {title: 'Export State Change Log'},
    });

}

module.config(stateChangeStates);

